import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value || 0);

const SegmentTrendChart = ({ data = [], dataKey, label, color = "#2AF598" }) => {
  const chartData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label,
        data: data.map((item) => item[dataKey]),
        borderColor: color,
        backgroundColor: `${color}22`,
        tension: 0.35,
        fill: true,
        pointRadius: 3,
        pointHoverRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { labels: { color: "#fff", usePointStyle: true, padding: 16 } },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.86)",
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: color,
        borderWidth: 1,
        callbacks: {
          label: (context) => `${label}: ${formatCurrency(context.parsed.y)}`,
        },
      },
    },
    scales: {
      x: {
        grid: { color: "rgba(255, 255, 255, 0.08)", drawBorder: false },
        ticks: { color: "#aaa", maxRotation: 45, minRotation: 0 },
      },
      y: {
        grid: { color: "rgba(255, 255, 255, 0.08)", drawBorder: false },
        ticks: { color: "#aaa", callback: (value) => `$${Number(value / 1000).toFixed(0)}K` },
      },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default SegmentTrendChart;
